const trackingURL = (carrier, trackingNumber) => {
  const carriers = {
    APC: "http://dm.mytracking.net/APC/Track/TrackDetails.aspx?t=",
    FEDEX:
      "https://www.fedex.com/apps/fedextrack/?action=track&language=english&tracknumbers=",
    USPS: "https://tools.usps.com/go/TrackConfirmAction.action?tLabels=",
    LANDMARK: "https://track.landmarkglobal.com/?trck=",
    LGINTSTD: "https://track.landmarkglobal.com/?trck=",
    LGINTPOST: "https://track.landmarkglobal.com/?trck="
  };

  if (!carrier || !trackingNumber) {
    return "#";
  }

  const baseUrl = carriers[carrier.toUpperCase()];
  if (baseUrl) {
    return `${baseUrl}${trackingNumber}`;
  }

  return "#";
};

export default {
  getTrackingURL: trackingURL
};



// WEBPACK FOOTER //
// ./src/utils/shipping.js